import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import { SUPPORTED_LANGS, getLangSync, onLangLoaded } from './langResources';

const resources = Object.fromEntries(
    SUPPORTED_LANGS.filter((code) => getLangSync(code)).map((code) => [code, { translation: getLangSync(code) }])
);
i18n
    .use(detector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: "eng",
        keySeparator: false,
        interpolation: {
            escapeValue: false
        }
});

onLangLoaded((code, data) => {
    i18n.addResourceBundle(code, 'translation', data, true, true);
});

export default i18n;